@use 'vars';

$ICON_SIZE: 30px;

.actions-menu-item {
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 calc(50% - 50px);
  border: none;

  &:hover {
    cursor: pointer;

    .actions-menu-item__content__arrow-container {
      margin-right: 0;
    }
  }

  &__content-container {
    display: flex;
    width: 100%;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &__text__title {
    font-weight: vars.$font-weight-book;
  }

  &__text {
    display: flex;
    flex-direction: column;
  }

  &__text__description {
    font-size: vars.$font-size-small;
    color: vars.$dark-grey;
  }

  &__content__arrow-container {
    transition: vars.$slide-right;
  }

  // compact specific styles
  &--compact {
    transition: vars.$slide-right;
    display: unset;

    &:first-child {
      margin-top: vars.$margin-xxsmall;
    }

    &__content-container {
      gap: vars.$gap-small;

      .actions-menu-item__icon {
        display: flex;
        width: 20px;
        align-items: center;
        justify-content: center;
      }
    }

    .actions-menu-item__text__title {
      font-size: vars.$font-size-small;
      font-weight: vars.$font-weight-book;
    }

    &__content__arrow-container {
      margin-right: vars.$gap-xsmall;
    }

    &:hover {
      background: none;
    }
  }

  // comfortable specific styles
  &--comfortable {
    padding: vars.$padding-small 0;
    transition: vars.$slide-right;
    display: unset;

    &__content-container {
      gap: vars.$gap-small;

      .actions-menu-item__icon {
        display: flex;
        width: 20px;
        align-items: center;
        justify-content: center;
      }
    }

    .actions-menu-item__text__title {
      font-size: vars.$font-size-small;
      font-weight: vars.$font-weight-book;
    }

    &__content__arrow-container {
      margin-right: vars.$gap-xsmall;
    }

    &:hover {
      background: none;
    }
  }

  // stand alone specific styles
  &--stand_alone {
    border-radius: vars.$border-radius-small;
    border: vars.$border-size-thin solid vars.$ai-primary;
    padding: 12px vars.$padding-medium;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    min-width: 100px;
    height: $ICON_SIZE;
    transition: vars.$slide-right;

    &:hover {
      background-color: vars.$light-grey;
      cursor: pointer;
    }

    .actions-menu-item__content-container {
      justify-content: center;
      gap: vars.$gap-xsmall;
    }

    .actions-menu-item__content {
      justify-content: center;
      width: auto;
    }

    .actions-menu-item__text__title {
      font-size: vars.$font-size-extra-small !important;
      font-weight: vars.$font-weight-book;
      color: vars.$ai-primary;
      white-space: nowrap;
    }

    &__content__arrow-container {
      display: none;
    }

    &:hover {
      cursor: pointer;
    }
  }
}
